import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function LoginSuccess() {
  const { setUser, setToken } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);

    const token = params.get("token");
    const first_name = params.get("first_name");
    const email = params.get("email");
    const image = params.get("image");
    const id = params.get("id");
    const sub_id = params.get("sub_id");
    const plan_id = params.get("plan_id");
    const subscription_title = params.get("subscription_title");
    const amount = params.get("amount");
    const features = params.get("features");
    const subscription_status = params.get("subscription_status");
    const end_date = params.get("end_date");

    if (token && first_name && email) {
      const subscriptionData =
        sub_id && plan_id
          ? {
              id: sub_id,
              plan_id: plan_id,
              title: subscription_title || "",
              amount: amount || "",
              features: features ? JSON.parse(features) : [],
              status: subscription_status || "",
              end_date: end_date || "",
            }
          : null;

      const user = {
        id,
        name: first_name,
        email,
        image,
        subscription: subscriptionData,
        role: "user",
      };

      // ✅ Update AuthContext
      setUser(user);
      setToken(token);

      // ✅ Store in localStorage
      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_user", JSON.stringify(user));
      localStorage.setItem("user_id", id);
      localStorage.setItem("uemail", email);
      localStorage.setItem("sub_id", sub_id || "");
      localStorage.setItem("plan_id", plan_id || "");

      // ✅ Redirect to app
      setTimeout(() => {
        window.location.replace("/");
      }, 200);
    } else {
      navigate("/login");
    }
  }, [location, navigate, setUser, setToken]);

  return <div>Logging in...</div>;
}

export default LoginSuccess;
